import { useRoute, useRouter } from 'vue-router/composables';
import { computed } from 'vue';
import { createGlobalState } from '@vueuse/core';

interface IFamilySearchUrlParams {
    familySearchIndex?: number;
    familySearchType?: 'simple' | 'inpadoc' | 'extend' | 'apno';
    type?: string;
    q?: string;
    efq?: string;
    patentId?: string;
    page?: number;
}

export const useFamilySearchUrlParams = createGlobalState(() => {
    const route = useRoute();
    const router = useRouter();

    const familySearchIndex = computed(() => {
        return route.query.FSI ? Number(route.query.FSI) : 0;
    });

    const familySearchType = computed(() => {
        return (route.query.FST || '') as string;
    });

    const type = computed(() => {
        return (route.query._type || '') as string;
    });

    const q = computed(() => {
        return (route.query.q || '') as string;
    });

    const efq = computed(() => {
        return (route.query.efq || '') as string;
    });

    const patentId = computed(() => {
        return (route.query.patentId || '') as string;
    });

    const page = computed(() => {
        return 1;
        // return route.query.page ? Number(route.query.page) : 1;
    });

    const workspaceId = computed(() => {
        return route.query.workspace_id as string;
    });

    const folderId = computed(() => {
        return route.query.folder_id as string;
    });


    // workspace跳转过来给右侧列表使用的参数
    const qid = computed(() => {
        return route.query.qid as string;
    });

    const efqid = computed(() => {
        return route.query.efqid as string;
    });

    const layerId = computed(() => {
        return route.query.layer_id as string;
    });

    const fieldId = computed(() => {
        return route.query.field_id as string;
    });

    const aiFieldId = computed(() => {
        return route.query.ai_field_id as string;
    });

    const sort = computed(() => {
        return route.query.sort as string;
    });

    const bioUk = computed(() => {
        return route.query.bio_uk as string;
    });

    const updateUrlParams = (updateValues: IFamilySearchUrlParams) => {
        const query = { ...route.query };

        const needUpdateFamilySearchIndex = updateValues.familySearchIndex && (String(updateValues.familySearchIndex) !== query.FSI);
        const needUpdateFamilySearchType = updateValues.familySearchType && (updateValues.familySearchType !== query.FST);
        const needUpdatePage = updateValues.page && (String(updateValues.page) !== query.page);
        const needUpdatePatentId = updateValues.patentId && (updateValues.patentId !== query.patentId);

        if (!needUpdateFamilySearchIndex && !needUpdateFamilySearchType && !needUpdatePage && !needUpdatePatentId) return;

        if (updateValues.familySearchIndex) query.FSI = String(updateValues.familySearchIndex);
        if (updateValues.familySearchType) query.FST = updateValues.familySearchType;
        if (updateValues.page) query.page = String(updateValues.page);
        if (updateValues.patentId) query.patentId = updateValues.patentId;

        const navigationInfo = route.name
            ? { name: route.name, params: route.params, query }
            : { path: route.path, params: route.params, query };

        router.push(navigationInfo);
    };

    return {
        familySearchIndex,
        familySearchType,
        type,
        q,
        efq,
        patentId,
        page,
        workspaceId,
        folderId,
        qid,
        efqid,
        layerId,
        fieldId,
        aiFieldId,
        sort,
        bioUk,
        updateUrlParams,
    };
});
